// English keys remain stable; only presentation follows the user's language.
export const reservationFormMessages = {
  "Floor": "Planta",
  "Bed type": "Tipo de cama",
  "View": "Vistas",
  "Check-in Date": "Fecha de entrada",
  "Check-out Date": "Fecha de salida",
  "Check-In → Check-Out": "Entrada → Salida",
  "Click to Select Dates": "Selecciona las fechas",
  "Edit Dates": "Editar fechas",
  "Check In": "Entrada",
  "Check Out": "Salida",
  "Previous Month": "Mes anterior",
  "Next Month": "Mes siguiente",
  "Month": "Mes",
  "Choose": "Elegir",
  "Not available": "No disponible",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "Nights": "Noches",
  "Adults": "Adultos",
  "Select": "Seleccionar",
  "Select Adults": "Seleccionar adultos",
  "No options available": "No hay opciones disponibles",
  "Children": "Niños",
  "Select Children": "Seleccionar niños",
  "Babies": "Bebés",
  "Room Category": "Categoría de habitación",
  "Click to Select Category": "Selecciona la categoría de habitación",
  "Select Category": "Seleccionar categoría de habitación",
  "Room": "Habitación",
  "Room selected": "Habitación seleccionada",
  "Click to Select Room Number": "Selecciona el número de habitación",
  "Select Room": "Seleccionar habitación",
  "No rooms available.": "No hay habitaciones disponibles.",
  "Select Room Category First": "Selecciona primero la categoría de habitación",
  "Room Rate": "Tarifa de habitación",
  "Click to Select Room Rate": "Selecciona la tarifa de habitación",
  "Select Room Rate": "Seleccionar tarifa de habitación",
  "No room rates available.": "No hay tarifas de habitación disponibles.",
  "Room Price": "Precio de la habitación",
  "See Nightly Breakdown": "Ver el desglose por noche",
  "Pending": "Pendiente",
  "Remove overrides and restore base nightly prices": "Eliminar los ajustes manuales y restaurar los precios base por noche",
  "Select a Room Rate first": "Selecciona primero una tarifa de habitación",
  "Apply overrides to nightly prices": "Aplicar ajustes manuales a los precios por noche",
  "Remove Override": "Eliminar ajuste manual",
  "Apply Override": "Aplicar ajuste manual",
  "Extras details": "Detalle de los extras",
  "No extras": "Sin extras",
  "Select a Room Rate first to manage extras": "Selecciona primero una tarifa de habitación para gestionar los extras",
  "Manage Extras": "Gestionar extras",
  "Total Extras": "Total de extras",
  "Total applied extras": "Total de extras aplicados",
  "Final Total Price": "Precio total final",
  "Reservation total including extras": "Total de la reserva con extras incluidos",
  "Check-in Time": "Hora de entrada",
  "Check-out Time": "Hora de salida",
  "Special Requests": "Peticiones especiales",
  "Reservation Status": "Estado de la reserva",
  "Unnamed Extra": "Extra sin nombre",
  "Save All Rooms": "Guardar todas las habitaciones",
  "Save Reservation": "Guardar reserva",
  "Delete All Rooms": "Eliminar todas las habitaciones",
  "Delete Reservation": "Eliminar reserva",
  "Nightly Breakdown": "Desglose por noche",
  "Close": "Cerrar",
  "Choose dates and rates to see the breakdown.": "Selecciona las fechas y la tarifa para ver el desglose.",
  "Loading…": "Cargando…",
  "Total": "Total",
  "Saving Reservation…": "Guardando reserva…",
  "check-In date cannot be before yesterday.": "La fecha de entrada no puede ser anterior a ayer.",
  "Reservations with Group Rate cannot be modified. Please delete and create a new reservation.": "Las reservas con tarifa de grupo no se pueden modificar. Elimina la reserva y crea una nueva.",
  "You can only edit reservations for one room at a time.\n\nPlease complete the other reservation (Room {roomIndex}) by selecting a rate before continuing.": "Solo puedes editar la reserva de una habitación a la vez.\n\nCompleta la otra reserva (habitación {roomIndex}) seleccionando una tarifa antes de continuar.",
  "Please select both dates.": "Selecciona ambas fechas.",
  "Check-out must be after check-in.": "La salida debe ser posterior a la entrada.",
  "No availability for the selected dates.": "No hay disponibilidad para las fechas seleccionadas.",
  "Error saving dates.": "No se han podido guardar las fechas.",
  "Check-Out date cannot be same or before the Check-In date.": "La fecha de salida debe ser posterior a la fecha de entrada.",
  "Error loading adults options.": "No se han podido cargar las opciones de adultos.",
  "Error saving adults.": "No se ha podido guardar el número de adultos.",
  "Error loading children options.": "No se han podido cargar las opciones de niños.",
  "Error saving children.": "No se ha podido guardar el número de niños.",
  "Error loading room categories.": "No se han podido cargar las categorías de habitación.",
  "Error saving room category.": "No se ha podido guardar la categoría de habitación.",
  "Error fetching available rooms.": "No se han podido cargar las habitaciones disponibles.",
  "Error saving room.": "No se ha podido guardar la habitación.",
  "Select dates first.": "Selecciona primero las fechas.",
  "Select number of adults first.": "Selecciona primero el número de adultos.",
  "Error loading room rates.": "No se han podido cargar las tarifas de habitación.",
  "Error applying room rate.": "No se ha podido aplicar la tarifa de habitación.",
  "This reservation does not have a saved breakdown yet.": "Esta reserva aún no tiene un desglose guardado.",
  "The nightly breakdown could not be loaded.": "No se ha podido cargar el desglose por noche.",
};
